<template>
    <!-- contents -->
    <div>
        <div class="view_cont">
            <dl class="view_subject">
                <dt class="subject voc_title">
                    {{ $t('FIELD.VOC.INFORMATION') }}
                </dt>
            </dl>

            <div class="view_question">
                <dl class="dl_view">
                    <dt>{{ $t('FIELD.VOC.NO') }}</dt>
                    <dd>{{ data.VOC_SEQ }}</dd>
                    <dt>{{ $t('FIELD.BP.NUMBER') }}</dt>
                    <dd>
                        <a href="javascript:" class="link_attch" @click="RequestVocUserInfoPopup">{{ data.BP_NO }}</a>
                    </dd>
                    <dt>{{ $t('FIELD.GLOBAL.REQUEST.DATE') }}</dt>
                    <dd>{{ data.VOC_DT }}</dd>
                </dl>
                <dl class="dl_view">
                    <dt>{{ $t('FIELD.GLOBAL.INQUIRY.TYPE') }}</dt>
                    <dd>{{ data.INQUIRY_TYPE_NM }}</dd>
                    <dt>{{ $t('FIELD.GLOBAL.CATEGORY') }}</dt>
                    <dd>{{ data.CATE_MAIN_NM }} / {{ data.CATE_SUB_NM }}</dd>
                    <dt>{{ $t('FIELD.GLOBAL.MODEL.CODE') }}</dt>
                    <dd>{{ data.SELECT_MODEL_CODE }}</dd>
                </dl>
                <dl class="dl_write">
                    <dt>{{ $t('FIELD.GLOBAL.QNA.DESC') }}</dt>
                    <dd data-input-type="textarea">
                        <textarea class="textarea_ty w100p" v-model="queDesc" readonly></textarea>
                    </dd>
                </dl>
            </div>

            <!-- See the Question -->
            <section class="answer_question_wrap voc_question" v-if="'01' != status">
                <!-- class 주의 -->
                <p class="sec_title">
                    <em>{{ $t('FIELD.VOC.ANSWER.LINE') }}</em>
                </p>

                <dl class="dl_write">
                    <dt>{{ $t('FIELD.GLOBAL.ANS.DESC') }}<em class="txt_mandatory" v-if="'02' === status">*</em></dt>
                    <dd data-input-type="textarea">
                        <textarea
                            class="textarea_ty w100p"
                            v-model="ansDesc"
                            :readonly="'03' === status ? true : false"
                        >
                        </textarea>
                    </dd>
                </dl>
            </section>
            <!-- //See the Question -->

            <div class="btn_wrap_full topLine">
                <!-- <a href="javascript:" class="btn_white size_full" @click="goListBack">{{ $t('BUTTON.GLOBAL.LIST') }}</a> -->
                <a href="javascript:" class="btn_white" @click="goListBack">
                    {{ $t('BUTTON.GLOBAL.LIST') }}
                </a>
                <div class="btn_right pc_only">
                    <a href="javascript:" class="btn_blue" v-if="btnShow('01')" @click="save('02')">
                        {{ $t('BUTTON.GLOBAL.ACCEPT') }}
                    </a>
                    <a href="javascript:" class="btn_blue" v-if="btnShow('02')" @click="save('03')">
                        {{ $t('FIELD.FAST.ANSWER') }}/{{ $t('BUTTON.GLOBAL.COMPLETE') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import moment from 'moment';
import { EventBus } from '@/utils/EventBus';
import { SDLUtil, DateUtil, MenuUtil } from '@/utils';
import { mapActions, mapGetters } from 'vuex';
import RequestVocUserInfoPopup from '~vb/eur/voc/RequestVocUserInfoPopup';

const searchUserInfo = bpNo => {
    let api = `${SDLUtil.API_URL}/basis/eur/getUserInfo.skp`;
    return axios.post(api, qs.stringify({ bpNo: bpNo }));
};

export default {
    name: 'requestVocDetail',
    props: {
        params: {},
        data: { type: Object, default: {} },
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            menuParams: 'getParams',
        }),
    },
    data() {
        return {
            status: '',
            queDesc: '',
            ansDesc: '',
        };
    },
    methods: {
        async save(v) {
            if (SDLUtil.isNull(this.ansDesc) && '03' === v) {
                SDLUtil.alert('FIELD.GLOBAL.ETC.082');
                return false;
            }

            SDLUtil.showLoadingBar(true);
            let saveParams = {
                vocSeq: this.data.VOC_SEQ,
                vocStatus: v,
                ansDesc: SDLUtil.nvl(this.ansDesc),
                loginNo: this.loginNo,
            };
            let url = `${SDLUtil.API_URL}/basis/eur/saveVoc.skp`;
            axios
                .post(url, qs.stringify(saveParams))
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    this.status = resp.data.search.vocStatus;
                    this.ansDesc = resp.data.search.ansDesc;
                    if ('03' === this.status) {
                        this.goListBack();
                    }
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        btnShow(v) {
            let result = false;
            if (v === this.status && 'Y' === this.menuParams.creationYn) {
                result = true;
            }
            return result;
        },
        goListBack() {
            EventBus.$emit('goVocListBack', 1);
        },
        RequestVocUserInfoPopup() {
            searchUserInfo(this.data.BP_NO)
                .then(resp => {
                    SDLUtil.show(
                        RequestVocUserInfoPopup,
                        {
                            data: resp.data.result,
                        },
                        {
                            width: '500px',
                            height: 'auto',
                        },
                    );
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        stripHtml(html) {
            var tmp = document.createElement('html');
            tmp.innerHTML = SDLUtil.nvl(html);
            return tmp.textContent || tmp.innerText || '';
        },
    },
    mounted() {
        this.status = this.data.VOC_STATUS;
        this.queDesc = this.stripHtml(this.data.QUESTION_DESC);
        this.ansDesc = this.stripHtml(this.data.SOLUTION_DESC);
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/voc/RequestVocDetail.vue